export const tableLoadingData = [
	[
		{
			column: 'Gene.symbol',
			id: 4000004,
			class: 'Gene',
			value: '0610005C13Rik',
			url: '/report.do?id=4000004',
		},
		{
			column: 'Gene.name',
			id: 4000004,
			class: 'Gene',
			value: 'RIKEN cDNA 0610005C13 gene',
			url: '/report.do?id=4000004',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000004,
			class: 'Gene',
			value: 'MGI:1918911',
			url: '/report.do?id=4000004',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000004,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000004',
		},
		{
			column: 'Gene.length',
			id: 4000004,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000004',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000005,
			class: 'Gene',
			value: '0610006L08Rik',
			url: '/report.do?id=4000005',
		},
		{
			column: 'Gene.name',
			id: 4000005,
			class: 'Gene',
			value: 'RIKEN cDNA 0610006L08 gene',
			url: '/report.do?id=4000005',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000005,
			class: 'Gene',
			value: 'MGI:1923503',
			url: '/report.do?id=4000005',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000005,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000005',
		},
		{
			column: 'Gene.length',
			id: 4000005,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000005',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000006,
			class: 'Gene',
			value: '0610008J02Rik',
			url: '/report.do?id=4000006',
		},
		{
			column: 'Gene.name',
			id: 4000006,
			class: 'Gene',
			value: 'RIKEN cDNA 0610008J02 gene',
			url: '/report.do?id=4000006',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000006,
			class: 'Gene',
			value: 'MGI:1925547',
			url: '/report.do?id=4000006',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000006,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000006',
		},
		{
			column: 'Gene.length',
			id: 4000006,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000006',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000007,
			class: 'Gene',
			value: '0610009B22Rik',
			url: '/report.do?id=4000007',
		},
		{
			column: 'Gene.name',
			id: 4000007,
			class: 'Gene',
			value: 'RIKEN cDNA 0610009B22 gene',
			url: '/report.do?id=4000007',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000007,
			class: 'Gene',
			value: 'MGI:1913300',
			url: '/report.do?id=4000007',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000007,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000007',
		},
		{
			column: 'Gene.length',
			id: 4000007,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000007',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000008,
			class: 'Gene',
			value: '0610009E02Rik',
			url: '/report.do?id=4000008',
		},
		{
			column: 'Gene.name',
			id: 4000008,
			class: 'Gene',
			value: 'RIKEN cDNA 0610009E02 gene',
			url: '/report.do?id=4000008',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000008,
			class: 'Gene',
			value: 'MGI:3698435',
			url: '/report.do?id=4000008',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000008,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000008',
		},
		{
			column: 'Gene.length',
			id: 4000008,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000008',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000009,
			class: 'Gene',
			value: '0610009F21Rik',
			url: '/report.do?id=4000009',
		},
		{
			column: 'Gene.name',
			id: 4000009,
			class: 'Gene',
			value: 'RIKEN cDNA 0610009F21 gene',
			url: '/report.do?id=4000009',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000009,
			class: 'Gene',
			value: 'MGI:1918921',
			url: '/report.do?id=4000009',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000009,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000009',
		},
		{
			column: 'Gene.length',
			id: 4000009,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000009',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
	[
		{
			column: 'Gene.symbol',
			id: 4000010,
			class: 'Gene',
			value: '0610009K14Rik',
			url: '/report.do?id=4000010',
		},
		{
			column: 'Gene.name',
			id: 4000010,
			class: 'Gene',
			value: 'RIKEN cDNA 0610009K14 gene',
			url: '/report.do?id=4000010',
		},
		{
			column: 'Gene.primaryIdentifier',
			id: 4000010,
			class: 'Gene',
			value: 'MGI:1918931',
			url: '/report.do?id=4000010',
		},
		{
			column: 'Gene.secondaryIdentifier',
			id: 4000010,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000010',
		},
		{
			column: 'Gene.length',
			id: 4000010,
			class: 'Gene',
			value: null,
			url: '/report.do?id=4000010',
		},
		{
			column: 'Gene.organism.name',
			id: 4000003,
			class: 'Organism',
			value: 'Mus musculus',
			url: '/report.do?id=4000003',
		},
	],
]
